import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';

const DEFAULT_TEXT = `POLÍTICA DE PRIVACIDAD

Última actualización: 21 de febrero de 2026

1. Marco legal
El tratamiento de datos se realiza conforme a la LFPDPPP, su Reglamento y lineamientos aplicables en México.

2. Datos tratados
Se pueden tratar datos de cuenta, logs técnicos, configuración, contenido de plantillas y metadatos operativos.

3. Finalidades
Autenticación, autorización, renderizado, operación del servicio, soporte, seguridad y prevención de abuso.

4. Seguridad
Se aplican medidas técnicas y administrativas razonables para proteger confidencialidad, integridad y disponibilidad.

5. Derechos ARCO
Las solicitudes de Acceso, Rectificación, Cancelación u Oposición se atienden conforme a la normativa mexicana.`;

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState(DEFAULT_TEXT);
  const [updatedAt, setUpdatedAt] = useState('21 de febrero de 2026');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await api.getPublicLegalContent();
        if (!mounted) return;
        setContent(data?.privacyPolicy || DEFAULT_TEXT);
        if (data?.updatedAt) {
          setUpdatedAt(new Date(data.updatedAt).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }));
        }
      } catch {
        if (mounted) setContent(DEFAULT_TEXT);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <div className="legal-page__top">
          <Link className="legal-page__back" to="/">← Volver al inicio</Link>
          <p className="legal-page__updated">Última actualización: {updatedAt}</p>
        </div>

        <h1>Política de Privacidad</h1>
        <div className="legal-page__text">{content}</div>
      </div>
    </div>
  );
}
